import { createSelector } from "reselect";

export const getFeatures = ({ VehicleChecklistTemplate_reducer }) => {
    return VehicleChecklistTemplate_reducer.features;
};
export const getTemplates = ({ VehicleChecklistTemplate_reducer }) => {
    return VehicleChecklistTemplate_reducer.templates;
};
export const getArchieveTemplates = ({ VehicleChecklistTemplate_reducer }) => {
    return VehicleChecklistTemplate_reducer.archieves;
};
export const getCustomInspections = ({ VehicleChecklistTemplate_reducer }) => {
    return VehicleChecklistTemplate_reducer.inspections;
};
export const getSelectedTemplate = ({ VehicleChecklistTemplate_reducer }) => {
    return VehicleChecklistTemplate_reducer.copyTemplate;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.user;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};

export const selectProfileConfig = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};

export const selectPermissions = createSelector(
    [selectConfig, selectProfileConfig],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level] ? config[access_level] : false;
        } else return false;
    }
);

export const canRead = createSelector([selectPermissions], (config = false) => {
    return config["vehiclechecklist_template"]
        ? config["vehiclechecklist_template"].read
        : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["vehiclechecklist_template"]
            ? config["vehiclechecklist_template"].update
            : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["vehiclechecklist_template"]
            ? config["vehiclechecklist_template"].create
            : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["vehiclechecklist_template"]
            ? config["vehiclechecklist_template"].delete
            : true;
    }
);

export const getUserProfile = createSelector([selectProfile], profiles => {
    if (
        profiles === false ||
        typeof profiles === "undefined" ||
        profiles === null
    ) {
        return [];
    }
    let name = profiles.profile.first_name + profiles.profile.last_name
    let uid = profiles.profile.uid
    return {
        name,
        uid
    };
});

export const selectTemplate = createSelector([getTemplates], templates => {
    if (
        templates === false ||
        typeof templates === "undefined" ||
        templates === null
    ) {
        return [];
    }

    let regTemplates = Object.keys(templates).map(e => {
            return templates[e]; 
    });
    return regTemplates;
});

export const selectTemplateName = createSelector([getTemplates], templates => {
    let titleArr = []
    if (
        templates === false ||
        typeof templates === "undefined" ||
        templates === null
    ) {
        return [];
    }

    Object.values(templates).map(e => {
            titleArr.push(e.profile.title)
            return null; 
    });
    return titleArr;
});

export const selectArchieveTemplateName = createSelector([getArchieveTemplates], templates => {
    let titleArr = []
    if (
        templates === false ||
        typeof templates === "undefined" ||
        templates === null
    ) {
        return [];
    }

    Object.values(templates).map(e => {
            titleArr.push(e.profile.title)
            return null; 
    });
    return titleArr;
});

// ------------------------------------------------------------------------------------------------------------------------
